import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const vocabularyFlashcardsManifest: FeatureManifest = {
  id: 'english-knowledge-vocabulary-flashcards',
  path: 'english-knowledge/flashcards/media-publishing/*',
  navPath: '/english-knowledge/flashcards/media-publishing',
  label: 'Media & phát hành',
  description: 'Thêm ảnh, audio và xuất bản các bộ từ vựng',
  navigationGroup: { id: 'flashcards', label: 'Flashcards' },
  load: () => import('./entry'),
}
